import { loginApi } from './axiosClient'

export default {
  login: (email, password) =>
    loginApi.post('auth/analytics/login', {
      email,
      password,
    }),
}
